import * as Yup from 'yup';

export const orderDetailSchema = Yup.object().shape({
  items: Yup.array()
    .of(
      Yup.object()
        .shape({
          product: Yup.object()
            .shape({
              value: Yup.number(),
              label: Yup.string(),
            })
            .nullable()
            .required('required'),
          id: Yup.string().optional(),
          quantity: Yup.number().required('required'),
          discount: Yup.number().optional().default(0),
          discountNumber: Yup.number().optional().default(0),
          description: Yup.string().notRequired(),
        })
        .required('required')
    )
    .min(1, 'un item es requerido como minimo')
    .required('required'),
});
export const orderProductGridSchema = Yup.object()
  .shape({
    product: Yup.object()
      .shape({
        value: Yup.number(),
        label: Yup.string(),
      })
      .required('required'),
    category: Yup.object().shape({
      value: Yup.number(),
      label: Yup.string(),
    }),
    id: Yup.string().optional(),
    quantity: Yup.number().required('required').min(1, '1 es el minimo'),
    description: Yup.string().notRequired(),
  })
  .required('required');
